import * as types from './constants';
import initialState from './initialState';
import _ from 'lodash';

export default function projectReducer(state = initialState, action) {
    switch (action.type) {
        case types.LOAD_PROJECTS_SUCCESS:
            return {
                projects: action.projects,
                errors: {}
            };

        case types.LOAD_PROJECT_SUCCESS:
            return {
                projects: state.projects,
                project: action.project,
                errors: {}
            };

        case types.STORE_PROJECT_SUCCESS:
            return {
                projects: [
                    ...state.projects,
                    action.project
                ],
                errors: {}
            };

        case types.STORE_PROJECT_FAILURE:
            return prepareStoreProjectFailure(state, action);


        case types.UPDATE_PROJECT_SUCCESS:
            return {
                projects: updateProject(state, action),
                project: Object.assign({},action.project),
                errors: {}
            };

        case types.ADD_PROJECT_MEMBER_SUCCESS:
            return Object.assign({}, state, {
                project: Object.assign({}, state.project, {
                    members: [action.user, ...state.project.members]
                })
            });

        case types.REMOVE_PROJECT_MEMBER_SUCCESS:
            return Object.assign({}, state, {
                project: Object.assign({}, state.project, {
                    members: [...state.project.members.filter(member => member.id !== action.user.id)]
                })
            });

        case types.LOAD_PROJECT_STATS_SUCCESS:
            return Object.assign({}, state, {
                stats: action.stats
            });

        default:
            return state;
    }
}

function prepareStoreProjectFailure(state, action) {
    let currentState = Object.assign({}, state);
    return Object.assign(currentState, {errors: action.errors});
}

function updateProject(state, action) {
    const project = action.project;
    const index = _.findIndex(state.projects, {id: project.id});
    let newState = _.clone(state.projects);
    newState = _.reject(newState, {id: project.id});
    newState.splice(index, 0, project);
    return newState;
}


/** WEBPACK FOOTER **
 ** ./src/container/ProjectContainer/reducers.js
 **/